import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import SubNav from "../../../shared/subnav/SubNav";
import PendingActions from "../pendingActions/PendingActions";
import HasPermissionTo from "../../../common/HasPermissionTo";
import ReservationRelease from "./reservationRelease/ReservationRelease";

const NscDashboard = (props) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, tab) => {
    setSelectedTab(tab);
  };

  const getTabs = () => {
    return [
      {
        menuName: props.t("ProgressBar.notifications"),
        enabled: true,
        id: "notifications",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "pendingActionQueue:view"
        ),
      },
      {
        menuName: props.t("ProgressBar.release"),
        enabled: true,
        id: "release",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "reservationReleaseTab"
        ),
      },
    ];
  };

  return (
    <section className="pageWrapper">
      <SubNav
        dashboard={true}
        selectedTab={selectedTab}
        title={props.t("GlobalNavBar.dashboard")}
        action={handleTabChange}
        tabs={getTabs()}
        {...props}
      />

      {selectedTab === 0 ? (
        <HasPermissionTo
          perform={["pendingActionQueue:view"]}
          permissions={props.user.permissions.rolePermissions}
          render={() => <PendingActions {...props} />}
        />
      ) : (
        selectedTab === 1 && (
          <HasPermissionTo
            perform={["reservationReleaseTab"]}
            permissions={props.user.permissions.rolePermissions}
            render={() => <ReservationRelease {...props} />}
          />
        )
      )}
    </section>
  );
};

export default withTranslation("emp")(NscDashboard);
